import { render, staticRenderFns } from "./PinItem.vue?vue&type=template&id=18acc857&scoped=true"
import script from "./PinItem.vue?vue&type=script&lang=ts"
export * from "./PinItem.vue?vue&type=script&lang=ts"
import style0 from "./PinItem.vue?vue&type=style&index=0&id=18acc857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@7.1.2_webpack@5.99.8__ejs@3.1.10_handl_3jut7ceevhzic45wtfkktzvvoq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18acc857",
  null
  
)

export default component.exports